export enum EOIDocumentSigningStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Signed = 'Signed',
  Error = 'Error',
  Recalled = 'Recalled',
}

export default EOIDocumentSigningStatus;
